import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/fdd.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_dic = _resolveComponent("dic")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", {
      id: "formulario",
      class: "p-10 bg-cover bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/formulario.png`) + ')' })
    }, [
      _createVNode(_component_dic, { class: "space-y-4 text-gray-700 Mindset" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "container mx-auto p-6 max-w-6xl bg-white rounded-lg" }, [
            _createElementVNode("h1", { class: "font-bold text-center text-3xl uppercase TommyBlack" }, "La fiesta fue reprogramada para el 22 de Novimebre"),
            _createElementVNode("h1", { class: "font-bold text-center text-3xl uppercase TommyBlack py-5" }, "Si ya estabas acreditado podés ir con el mismo QR"),
            _createElementVNode("h1", { class: "font-bold text-center text-3xl uppercase TommyBlack" }, "Si te queres acreditar podes hacerlo en la nueva página de acreditaciones"),
            _createElementVNode("div", { class: "w-full text-center py-20" }, [
              _createElementVNode("a", {
                href: "https://acreditaciones.qreventos.com/fdd22112025",
                class: "Abo w-full sm:w-auto px-10 py-3 mt-3 text-2xl Mindset bg-transparent border border-[#ffb700] text-[#df4753] rounded-full hover:bg-[#ffb700] shadow-lg hover:scale-110"
              }, " ACREDITARME ")
            ]),
            _createElementVNode("div", { class: "container mx-auto py-10" }, [
              _createElementVNode("img", {
                class: "object-contain mx-auto",
                src: _imports_0,
                style: {"max-width":"300px"}
              })
            ])
          ], -1)
        ])),
        _: 1
      })
    ], 4)
  ], 64))
}